import { z } from 'zod';
import { slugRegex } from './admin-project-validation';

export const partnerFields = {
  title: z.string().trim().min(1).max(255),
  slug: z.string().trim().min(1).max(255).regex(slugRegex, 'Slug must be kebab-case'),
  imageKey: z.string().trim().min(1).nullish(),
  description: z.string().max(2000).nullish(),
  link: z.string().url().max(191).nullish(),
};

export const partnerWriteSchema = z.object(partnerFields);

export type PartnerWriteInput = z.infer<typeof partnerWriteSchema>;
